import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=665d297c"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports